var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmoothRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1252)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3044 88.3048C14.8208 88.8018 14.1641 90.5374 15.0728 91.811C34.0396 118.393 99.5393 126.412 150.454 86.7198C146.905 93.7369 144.546 99.7756 145.973 102.753C152.586 107.119 156.943 98.4653 159.711 78.4533C152.727 75.4706 134.762 67.1347 135.221 78.5632C137.996 81.3454 142.804 82.0776 148.799 81.8315C89.3598 121.917 44.1926 104.965 18.4295 88.5641C17.7935 88.1592 17.0192 88.0652 16.3044 88.3048Z",
    fill: "#FACD6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 134,
    fill: "white",
    transform: "matrix(0.5 0.866025 0.866025 -0.5 0 67)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoothRight);
export default __webpack_public_path__ + "static/media/smooth_right.c843d41209ef85c1a943abd82bd4334b.svg";
export { ForwardRef as ReactComponent };